import { render, staticRenderFns } from "./AiCallingVariableEditor.vue?vue&type=template&id=395b6028&scoped=true&"
import script from "./AiCallingVariableEditor.vue?vue&type=script&lang=js&"
export * from "./AiCallingVariableEditor.vue?vue&type=script&lang=js&"
import style0 from "./AiCallingVariableEditor.vue?vue&type=style&index=0&id=395b6028&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395b6028",
  null
  
)

export default component.exports